export default function HeaderProducts() {
  return <div className="text-primary text-center bgBrands pb-20 pt-32">
    <h2 className="text-2xl font-bold px-[5%]">Our Portfolio</h2>
    <p className="mt-4 px-[5%]">
      We focus on giving life to brands, in order to distribute the best
      quality products. Explore below some of the brands we manage:
    </p></div>
}